/**
 * Geometria da moldura dos gráficos de série das fichas — funções puras
 * (testadas em `fatias.test.ts`). O componente está em `GraficoTempo.tsx`.
 *
 * O gráfico é dividido em N fatias de largura igual, e tudo se refere ao
 * CENTRO da fatia: a barra de chuva, o ponto da cota, o rótulo do eixo e a
 * fatia sob o mouse. Um só sistema de posição é o que faz a leitura do hover
 * cair exatamente sobre o que se vê.
 */

/** Índices das fatias que ganham rótulo no eixo: o começo, os terços e o fim. */
export function marcasDoEixo(n: number): number[] {
  if (n <= 0) return [];
  return [0, Math.floor(n / 3), Math.floor((2 * n) / 3), n - 1].filter((i, k, a) => a.indexOf(i) === k);
}

/**
 * Fatia sob o ponteiro, a partir da fração horizontal (0–1) do gráfico.
 * `null` fora dele — a borda direita (fração 1) ainda é a última fatia.
 */
export function fatiaSob(fracao: number, n: number): number | null {
  if (n <= 0 || !Number.isFinite(fracao) || fracao < 0 || fracao > 1) return null;
  return Math.min(n - 1, Math.floor(fracao * n));
}

/** Posição horizontal (0–100 %) do centro da fatia `i`. */
export function centroPct(i: number, n: number): number {
  return ((i + 0.5) / n) * 100;
}
